<script setup>
import { inject, onMounted } from "vue";
import { TabsContent } from "reka-ui";
import { registerPanelInjectKey } from "~/components/base/Card/BaseCardWithTabs";

const props = defineProps({
  name: { type: String, required: true },
});

const registerPanel = inject(registerPanelInjectKey);

onMounted(() => {
  registerPanel(props.name);
});
</script>

<template>
  <TabsContent :value="name">
    <slot />
  </TabsContent>
</template>
